import React, { FC } from 'react'

import InputItem from '../../../components/InputItem'
import { ITabBaseProps } from './types'

export const ActivityData: FC<ITabBaseProps> = ({ isCustomEF, formik }) => {
  return (
    <div className="piece-content-inputs mb-5">
      <InputItem
        disabled={isCustomEF.current}
        name="Yield"
        description="Unit of Measure: kg"
        type="input"
        addonTitle="kg"
        onChange={e => {
          const val = (e.target as HTMLInputElement).value
          formik.setFieldValue('impacts.yield', val === '' ? null : val)
        }}
        formikName="impacts.yield"
        formik={formik}
        showAsterisk={false}
        defaultValue={formik.values.impacts.yield === 0 ? '0' : formik.values.impacts.yield}
      />
      <InputItem
        disabled={isCustomEF.current}
        name="Economic Value Share"
        description="Unit of Measure: %"
        type="input"
        addonTitle="%"
        onChange={e => {
          const val = (e.target as HTMLInputElement).value
          formik.setFieldValue('impacts.economicValueShare', val === '' ? null : val)
        }}
        formikName="impacts.economicValueShare"
        formik={formik}
        showAsterisk={false}
        defaultValue={
          formik.values.impacts.economicValueShare === 0
            ? '0'
            : formik.values.impacts.economicValueShare
        }
      />
      <InputItem
        disabled={isCustomEF.current}
        name="Above Ground crop residue - left on field"
        description="Unit of Measure: kg dry matter"
        type="input"
        addonTitle="kg dry matter"
        onChange={e => {
          const val = (e.target as HTMLInputElement).value
          formik.setFieldValue('impacts.aboveGroundCropResidueLeftOnField', val === '' ? null : val)
        }}
        formikName="impacts.aboveGroundCropResidueLeftOnField"
        formik={formik}
        showAsterisk={false}
        defaultValue={
          formik.values.impacts.aboveGroundCropResidueLeftOnField === 0
            ? '0'
            : formik.values.impacts.aboveGroundCropResidueLeftOnField
        }
      />
      <InputItem
        disabled={isCustomEF.current}
        name="Above Ground crop residue - removed"
        description="Unit of Measure: kg dry matter"
        type="input"
        addonTitle="kg dry matter"
        onChange={e => {
          const val = (e.target as HTMLInputElement).value
          formik.setFieldValue('impacts.aboveGroundCropResidueRemoved', val === '' ? null : val)
        }}
        formikName="impacts.aboveGroundCropResidueRemoved"
        formik={formik}
        showAsterisk={false}
        defaultValue={
          formik.values.impacts.aboveGroundCropResidueRemoved === 0
            ? '0'
            : formik.values.impacts.aboveGroundCropResidueRemoved
        }
      />
      <InputItem
        disabled={isCustomEF.current}
        name="Above Ground crop residue - burnt"
        description="Unit of Measure: kg dry matter"
        type="input"
        addonTitle="kg dry matter"
        onChange={e => {
          const val = (e.target as HTMLInputElement).value
          formik.setFieldValue('impacts.aboveGroundCropResidueBurnt', val === '' ? null : val)
        }}
        formikName="impacts.aboveGroundCropResidueBurnt"
        formik={formik}
        showAsterisk={false}
        defaultValue={
          formik.values.impacts.aboveGroundCropResidueBurnt === 0
            ? '0'
            : formik.values.impacts.aboveGroundCropResidueBurnt
        }
      />
      <InputItem
        disabled={isCustomEF.current}
        name="Below Ground crop residue"
        description="Unit of Measure: kg dry matter"
        type="input"
        addonTitle="kg dry matter"
        onChange={e => {
          const val = (e.target as HTMLInputElement).value
          formik.setFieldValue('impacts.belowGroundCropResidue', val === '' ? null : val)
        }}
        formikName="impacts.belowGroundCropResidue"
        formik={formik}
        showAsterisk={false}
        defaultValue={
          formik.values.impacts.belowGroundCropResidue === 0
            ? '0'
            : formik.values.impacts.belowGroundCropResidue
        }
      />
      <InputItem
        disabled={isCustomEF.current}
        name="Seed"
        description="Unit of Measure: kg"
        type="input"
        addonTitle="kg"
        onChange={e => {
          const val = (e.target as HTMLInputElement).value
          formik.setFieldValue('impacts.seed', val === '' ? null : val)
        }}
        formikName="impacts.seed"
        formik={formik}
        showAsterisk={false}
        defaultValue={formik.values.impacts.seed === 0 ? '0' : formik.values.impacts.seed}
      />
      <InputItem
        disabled={isCustomEF.current}
        name="Inorganic Fertiliser"
        description="Unit of Measure: kg N"
        type="input"
        addonTitle="kg N"
        onChange={e => {
          const val = (e.target as HTMLInputElement).value
          formik.setFieldValue('impacts.inorganicFertiliser_N', val === '' ? null : val)
        }}
        formikName="impacts.inorganicFertiliser_N"
        formik={formik}
        showAsterisk={false}
        defaultValue={
          formik.values.impacts.inorganicFertiliser_N === 0
            ? '0'
            : formik.values.impacts.inorganicFertiliser_N
        }
      />
      <InputItem
        disabled={isCustomEF.current}
        name="Inorganic Fertiliser"
        description="Unit of Measure: kg P2O5"
        type="input"
        addonTitle="kg P2O5"
        onChange={e => {
          const val = (e.target as HTMLInputElement).value
          formik.setFieldValue('impacts.inorganicFertiliser_P2O5', val === '' ? null : val)
        }}
        formikName="impacts.inorganicFertiliser_P2O5"
        formik={formik}
        showAsterisk={false}
        defaultValue={
          formik.values.impacts.inorganicFertiliser_P2O5 === 0
            ? '0'
            : formik.values.impacts.inorganicFertiliser_P2O5
        }
      />
      <InputItem
        disabled={isCustomEF.current}
        name="Inorganic Fertiliser"
        description="Unit of Measure: kg K2O"
        type="input"
        addonTitle="kg K2O"
        onChange={e => {
          const val = (e.target as HTMLInputElement).value
          formik.setFieldValue('impacts.inorganicFertiliser_K2O', val === '' ? null : val)
        }}
        formikName="impacts.inorganicFertiliser_K2O"
        formik={formik}
        showAsterisk={false}
        defaultValue={
          formik.values.impacts.inorganicFertiliser_K2O === 0
            ? '0'
            : formik.values.impacts.inorganicFertiliser_K2O
        }
      />
      <InputItem
        disabled={isCustomEF.current}
        name="Organic Fertiliser"
        description="Unit of Measure: kg N"
        type="input"
        addonTitle="kg N"
        onChange={e => {
          const val = (e.target as HTMLInputElement).value
          formik.setFieldValue('impacts.organicFertiliser_N', val === '' ? null : val)
        }}
        formikName="impacts.organicFertiliser_N"
        formik={formik}
        showAsterisk={false}
        defaultValue={
          formik.values.impacts.organicFertiliser_N === 0
            ? '0'
            : formik.values.impacts.organicFertiliser_N
        }
      />
      <InputItem
        disabled={isCustomEF.current}
        name="Organic Fertiliser"
        description="Unit of Measure: kg P2O5"
        type="input"
        addonTitle="kg P2O5"
        onChange={e => {
          const val = (e.target as HTMLInputElement).value
          formik.setFieldValue('impacts.organicFertiliser_P2O5', val === '' ? null : val)
        }}
        formikName="impacts.organicFertiliser_P2O5"
        formik={formik}
        showAsterisk={false}
        defaultValue={
          formik.values.impacts.organicFertiliser_P2O5 === 0
            ? '0'
            : formik.values.impacts.organicFertiliser_P2O5
        }
      />
      <InputItem
        disabled={isCustomEF.current}
        name="Organic Fertiliser"
        description="Unit of Measure: kg K2O"
        type="input"
        addonTitle="kg K2O"
        onChange={e => {
          const val = (e.target as HTMLInputElement).value
          formik.setFieldValue('impacts.organicFertiliser_K2O', val === '' ? null : val)
        }}
        formikName="impacts.organicFertiliser_K2O"
        formik={formik}
        showAsterisk={false}
        defaultValue={
          formik.values.impacts.organicFertiliser_K2O === 0
            ? '0'
            : formik.values.impacts.organicFertiliser_K2O
        }
      />
      <InputItem
        disabled={isCustomEF.current}
        name="Lime"
        description="Unit of Measure: kg CaCO3"
        type="input"
        addonTitle="kg CaCO3"
        onChange={e => {
          const val = (e.target as HTMLInputElement).value
          formik.setFieldValue('impacts.lime', val === '' ? null : val)
        }}
        formikName="impacts.lime"
        formik={formik}
        showAsterisk={false}
        defaultValue={formik.values.impacts.lime === 0 ? '0' : formik.values.impacts.lime}
      />
      <InputItem
        disabled={isCustomEF.current}
        name="Pesticide"
        description="Unit of Measure: kg AI"
        type="input"
        addonTitle="kg AI"
        onChange={e => {
          const val = (e.target as HTMLInputElement).value
          formik.setFieldValue('impacts.pesticide', val === '' ? null : val)
        }}
        formikName="impacts.pesticide"
        formik={formik}
        showAsterisk={false}
        defaultValue={formik.values.impacts.pesticide === 0 ? '0' : formik.values.impacts.pesticide}
      />
      <InputItem
        disabled={isCustomEF.current}
        name="Diesel"
        description="Unit of Measure: kg"
        type="input"
        addonTitle="kg"
        onChange={e => {
          const val = (e.target as HTMLInputElement).value
          formik.setFieldValue('impacts.diesel', val === '' ? null : val)
        }}
        formikName="impacts.diesel"
        formik={formik}
        showAsterisk={false}
        defaultValue={formik.values.impacts.diesel === 0 ? '0' : formik.values.impacts.diesel}
      />
      <InputItem
        disabled={isCustomEF.current}
        name="Electricity"
        description="Unit of Measure: kWh"
        type="input"
        addonTitle="kWh"
        onChange={e => {
          const val = (e.target as HTMLInputElement).value
          formik.setFieldValue('impacts.electricity', val === '' ? null : val)
        }}
        formikName="impacts.electricity"
        formik={formik}
        showAsterisk={false}
        defaultValue={
          formik.values.impacts.electricity === 0 ? '0' : formik.values.impacts.electricity
        }
      />
      <InputItem
        disabled={isCustomEF.current}
        name="Irrigation"
        description="Unit of Measure: m3"
        type="input"
        addonTitle="m3"
        onChange={e => {
          const val = (e.target as HTMLInputElement).value
          formik.setFieldValue('impacts.irrigation', val === '' ? null : val)
        }}
        formikName="impacts.irrigation"
        formik={formik}
        showAsterisk={false}
        defaultValue={
          formik.values.impacts.irrigation === 0 ? '0' : formik.values.impacts.irrigation
        }
      />
      <InputItem
        disabled={isCustomEF.current}
        name="Land transformation"
        description=""
        type="input"
        onChange={e => {
          const val = (e.target as HTMLInputElement).value
          formik.setFieldValue('impacts.landTransformation', val === '' ? null : val)
        }}
        formikName="impacts.landTransformation"
        formik={formik}
        defaultValue={
          formik.values.impacts.landTransformation === 0
            ? '0'
            : formik.values.impacts.landTransformation
        }
      />
      <InputItem
        disabled={isCustomEF.current}
        name="Deforestation"
        description="Unit of Measure: m2"
        type="input"
        addonTitle="m2"
        onChange={e => {
          const val = (e.target as HTMLInputElement).value
          formik.setFieldValue('impacts.deforestation', val === '' ? null : val)
        }}
        formikName="impacts.deforestation"
        formik={formik}
        defaultValue={
          formik.values.impacts.deforestation === 0 ? '0' : formik.values.impacts.deforestation
        }
      />
      <InputItem
        disabled={isCustomEF.current}
        name="Site type"
        description=""
        type="input"
        onChange={e => {
          const val = (e.target as HTMLInputElement).value
          formik.setFieldValue('impacts.siteType', val === '' ? null : val)
        }}
        formikName="impacts.siteType"
        formik={formik}
        defaultValue={formik.values.impacts.siteType || ''}
      />
      <InputItem
        disabled={isCustomEF.current}
        name="Land cover"
        description=""
        type="input"
        onChange={e => {
          const val = (e.target as HTMLInputElement).value
          formik.setFieldValue('impacts.landCover', val === '' ? null : val)
        }}
        formikName="impacts.landCover"
        formik={formik}
        defaultValue={formik.values.impacts.landCover || ''}
      />
    </div>
  )
}

export default ActivityData
